import client from './graphQlClient';
import {
    GET_SHARERS,
    SEARCH_SHARERS,
    UPDATE_FIXTURE_VISIBILITY,
    UPDATE_ORDER_VISIBILITY,
} from './queries/VisibilityQueries';

export default class VisibilityApi {
    static search = (search, datasetId, cancelToken) => {
        return new Promise((resolve, reject) => {
            client()
                .query({
                    query: SEARCH_SHARERS,
                    fetchPolicy: 'no-cache',
                    variables: {
                        search,
                        datasetId,
                    },
                })
                .then((result) => {
                    resolve(result.data.searchSharers);
                });

            cancelToken?.promise.then((reason) => {
                reject(reason);
            });
        });
    };

    static get = (userIds, groupIds, cancelToken) => {
        return new Promise((resolve, reject) => {
            client()
                .query({
                    query: GET_SHARERS,
                    fetchPolicy: 'no-cache',
                    variables: {
                        userIds,
                        groupIds,
                    },
                })
                .then((result) => {
                    resolve(result.data.getSharers);
                });

            cancelToken?.promise.then((reason) => {
                reject(reason);
            });
        });
    };

    static update = (id, userIds, groupIds, isFixture, cancelToken) => {
        return new Promise((resolve, reject) => {
            client()
                .mutate({
                    mutation: isFixture
                        ? UPDATE_FIXTURE_VISIBILITY
                        : UPDATE_ORDER_VISIBILITY,
                    fetchPolicy: 'no-cache',
                    variables: {
                        id,
                        userIds,
                        groupIds,
                    },
                })
                .then((result) => {
                    resolve(
                        isFixture
                            ? result.data.updateFixtureVisibility
                            : result.data.updateOrderVisibility
                    );
                });

            cancelToken?.promise.then((reason) => {
                reject(reason);
            });
        });
    };
}
